<template>
  <validation-observer ref="form" v-slot="{ invalid }">
    <b-form @submit.prevent>
      <b-row class="mt-2">

        <!-- Name -->
        <b-col cols="12">
          <b-form-group
            label="Nombre:"
            label-for="name"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Nombre"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="UserIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="name"
                  v-model="item.name"
                  placeholder="Nombre"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Email -->
        <b-col cols="12">
          <b-form-group
            label="Correo electrónico:"
            label-for="email"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Correo electrónico"
              rules="required|email"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="MailIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="email"
                  v-model="item.email"
                  placeholder="Correo electrónico"
                  type="email"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Role -->
        <b-col cols="12">
          <b-form-group
            label="Rol:"
            label-for="role"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Rol"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-select
                  id="role"
                  v-model="item.role"
                  :options="optionsRoles"
                  placeholder="Selecciona un rol"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Auth type -->
        <b-col cols="12">
          <b-form-group
            label="Autenticación:"
            label-for="auth"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Autenticación"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-select
                  id="auth"
                  v-model="item.authType"
                  :options="optionsAuth"
                  placeholder="Selecciona un tipo de autenticación"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Password -->
        <b-col cols="12">
          <b-form-group
            label="Contraseña:"
            label-for="password"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Contraseña"
              :rules="passwordRules"
              vid="password"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="LockIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="password"
                  v-model="password"
                  placeholder="Contraseña"
                  type="password"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Password Confirmation -->
        <b-col cols="12">
          <b-form-group
            label="Confirmar contraseña:"
            label-for="passwordConfirmation"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Confirmar contraseña"
              :rules="passwordConfirmationRules"
              vid="passwordConfirmation"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="LockIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="passwordConfirmation"
                  v-model="password_confirmation"
                  placeholder="Confirmar contraseña"
                  type="password"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Notification Alert -->
        <b-col cols="12">
          <b-form-group
            label="Notificar alertas:"
            label-for="notification"
            label-cols-md="4"
          >
            <b-form-checkbox
              v-model="item.notification"
              switch
              style="margin-top: 0.5rem;"
            />
          </b-form-group>
        </b-col>

        <!-- Enabled -->
        <b-col cols="12">
          <b-form-group
            label="Habilitado:"
            label-for="enabled"
            label-cols-md="4"
          >
            <b-form-checkbox
              id="enabled"
              v-model="item.enabled"
              switch
              style="margin-top: 0.5rem;"
            />
          </b-form-group>
        </b-col>

        <!-- Info CreatedAt -->
        <b-col
          v-if="item.id > 0"
          cols="12"
        >
          <b-form-group
            label="Creado:"
            label-for="createdAt"
            label-cols-md="4"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="createdAt"
                :value="$moment.utc(item.createdAt).local().format('DD/MM/YYYY hh:mm:ss a')"
                placeholder="Creado"
                disabled
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info UpdatedAt -->
        <b-col
          v-if="item.id > 0"
          cols="12"
        >
          <b-form-group
            label="Actualizado:"
            label-for="updatedAt"
            label-cols-md="4"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="updatedAt"
                :value="$moment.utc(item.updatedAt).local().format('DD/MM/YYYY hh:mm:ss a')"
                placeholder="Actualizado"
                disabled
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- btn centered actions-->
        <b-col class="text-center mt-2">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            @click="close"
          >
            Cancelar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="ml-4"
            :disabled="loading || invalid"
            @click="handleSubmit"
          >
            <b-spinner
              v-if="loading"
              small
            />
            {{ loading ? 'Procesando...' : 'Guardar' }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>

     <!-- Warning Modal -->
    <b-modal id="warning-modal" hide-footer>
      <template #modal-title>
        Advertencia
      </template>
      <b-row class="mt-2">
        <b-col cols="12">
          <h5>
            Por favor, asegúrese de guardar bien la contraseña, no se mostrará más.
          </h5>
        </b-col>

        <!-- btn centered actions-->
        <b-col class="text-center mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="button"
            variant="primary"
            @click="save"
          >
            Aceptar
          </b-button>
        </b-col>
      </b-row>
      </b-modal>
  </validation-observer>
</template>

<script>
import {
  BFormGroup, BFormInput, BForm, BInputGroup, BInputGroupPrepend, BRow, BCol,
  BButton, BSpinner, BFormSelect, BFormCheckbox, BModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email, confirmed } from '@validations'

// Define the strong password rule
extend('strong_password', {
  validate: value => {
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    return strongPasswordRegex.test(value)
  },
  message: 'La contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una letra minúscula, un número y un carácter especial.'
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BSpinner,
    BFormSelect,
    BFormCheckbox,
    BModal,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      optionsRoles: [
        { value: 'user', text: 'Usuario' },
        { value: 'tech', text: 'Técnico' },
        { value: 'admin', text: 'Administrador' },
      ],
      optionsAuth: [
        { value: 'system', text: 'Sistema' },
        { value: 'microsoft', text: 'Microsoft' },
      ],
      required,
      email,
      confirmed,
      password: '',
      password_confirmation: '',
    }
  },
  computed: {
    passwordRules() {
      return this.item.id > 0 && !this.password ? '' : 'required|strong_password';
    },
    passwordConfirmationRules() {
      return this.item.id > 0 && !this.password ? '' : 'required|confirmed:password';
    }
  },
  methods: {
    handleSubmit() {
      if (this.item.id > 0 && !this.password) {
        this.save()
      } else {
        this.showWarning()
      }
    },
    showWarning() {
      this.$bvModal.show('warning-modal')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.password) {
            this.item.password = this.password
          }
          this.$emit('save', this.item)
          this.$bvModal.hide('warning-modal')
        }
      })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>